import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class ResponseTimeAverage extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Average"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(group => {
                            return (
                                    <Paper elevation={2} sx={{mb: "10px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>{group.salesName}</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}><strong>{group.leadsCount} leads</strong></Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={4}>
                                                <Box>Average</Box>
                                                <Box>{Global.formatTime(group.avgResponseTime)}</Box>
                                            </Grid>
                                            <Grid item xs={4} textAlign={"right"}>
                                                <Box>&lt; 1 Menit</Box>
                                                <Box>{group.totalUnderOneMinute}</Box>    
                                            </Grid>
                                            <Grid item xs={4} textAlign={"right"}>
                                                <Box>&gt; 1 Menit</Box>
                                                <Box>{group.totalHigherOneMinute}</Box>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default ResponseTimeAverage;